import React, { useEffect, useMemo, useState } from "react";
import Table from "../../../Common/Table";
import Pagination from "../../../Common/Pagination";
import apiService, { handleError } from "../../../Common/ApiCommon/ApiService";

const AverageTableHis = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [averageData, setAverageData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchAverageTableData = async () => {
    try {
      setLoading(true);
      const response = await apiService.get(`/reports/table_history`);

      const averages = response.avg_data.map((table) => ({
        table_name: table.table_name,
        avg_amount: `₹ ${table.avg_amount.toFixed(2)}`,
        avg_duration: table.avg_duration,
        estimated_monthly_amount: `₹ ${table.estimated_monthly_amount.toFixed(2)}`,
        estimated_monthly_duration: table.estimated_monthly_duration,
      }));

      setAverageData(averages);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchAverageTableData();
  }, []);

  // Define columns
  const columns = useMemo(
    () => [
      { Header: "Table Name", accessor: "table_name" },
      { Header: "Average Collection", accessor: "avg_amount" },
      { Header: "Estimate Monthly", accessor: "estimated_monthly_amount" },
      { Header: "Average Run Time", accessor: "avg_duration" },
      // { Header: "Estimate Monthly Duration", accessor: "estimated_monthly_duration" },
    ],
    []
  );

  // Pagination
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = averageData.slice(indexOfFirstRow, indexOfLastRow);

  return (
    <div className="flex flex-col p-4">
      {loading ? (
        <div className="text-center text-green700 font-medium py-4">Loading data...</div>
      ) : (
        <>
          <div className="my-2 mb-6 overflow-auto vertical max-h-[70vh] horizontalscroll">
            <Table columns={columns} data={currentRows} />
          </div>

          {/* Pagination */}
          <Pagination
            currentPage={currentPage}
            rowsPerPage={rowsPerPage}
            totalRows={averageData.length}
            onPageChange={setCurrentPage}
            onRowsPerPageChange={(newRows) => {
              setRowsPerPage(newRows);
              setCurrentPage(1);
            }}
          />
        </>
      )}
    </div>
  );
};

export default AverageTableHis;
